import news from './data'
export default {
  newsList: function () {
    return news.getNewsList().sort(function (el1, el2) {
      return el2.newsId - el1.newsId
    })
  },
  getLastestNews: function () {
    var lastestIndex = 5
    var lastestNewsList = this.newsList().slice(0, lastestIndex)
    return lastestNewsList
  },
  getNewsList: function () {
    return this.newsList()
  },
  getNews: function (newsId) {
    return this.newsList().find(news => news.newsId === parseInt(newsId))
  }
}



// WEBPACK FOOTER //
// ./src/json/news/news.js